export default __webpack_public_path__ + "static/media/Isolation_Certificate.6aee6263.pdf";